// Lib
import loadable from 'react-loadable';

export default loadable({
    loader: () =>
        import(
            /* webpackChunkName: "annotation-editor" */
            './AnnotationEditor'
        ),
    loading: () => null,
});
